import { Box, InputLabel, Stack, Tooltip, Typography } from '@mui/material'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import MiniPieChart from 'components/DataGrid/components/MiniPieChart'

interface ActiveCountProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const ActiveCountCell: FC<ActiveCountProps> = ({ params, densityStyles }) => {
  const { isParent: _isParent, org_uuid: _org_uuid, SK: _SK } = params?.row ?? {}
  //@ts-ignore
  const isAutoGenerated = params?.rowNode?.isAutoGenerated
  const { active = 0, inProgress = 0, monthToMonth = 0, dayNotice = 0, pending = 0 } = params?.row?.activeCount || {}
  const chartData = isAutoGenerated
    ? [{ label: 'active', value: params?.value, color: 'rgba(236, 195, 119, 1)' }]
    : [
        { label: 'active', value: active, color: 'rgb(80, 200, 120)' },
        { label: 'inProgress', value: inProgress, color: 'rgb(249, 167, 49)' },
        { label: 'monthToMonth', value: monthToMonth, color: 'rgb(22, 138, 239)' },
        { label: 'dayNotice', value: dayNotice, color: 'rgb(235, 77, 77)' },
        { label: 'pending', value: pending, color: 'rgb(187, 124, 239)' },
      ]

  return (
    <Box
      key={params?.row?.id}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        cursor: 'default',
      }}
    >
      {/* {isParent || isAutoGenerated ? ( */}
      <Tooltip
        title={
          <Stack sx={{ textAlign: 'left' }}>
            {isAutoGenerated ? (
              <Box className="data-grid-box-row" gap={2}>
                <InputLabel sx={{ color: 'rgba(236, 195, 119, 1)' }}>Total:</InputLabel>
                <Typography>{params?.value}</Typography>
              </Box>
            ) : (
              <>
                <Box className="data-grid-box-row">
                  <InputLabel sx={{ color: 'rgba(80, 200, 120, 0.6)' }}>Active:</InputLabel>
                  <Typography>{active}</Typography>
                </Box>
                <Box className="data-grid-box-row">
                  <InputLabel sx={{ color: 'rgba(249, 167, 49, 0.6)' }}>In Progress:</InputLabel>
                  <Typography>{inProgress}</Typography>
                </Box>
                <Box className="data-grid-box-row">
                  <InputLabel sx={{ color: 'rgba(22, 138, 239, 0.6)' }}>Month To Month:</InputLabel>
                  <Typography>{monthToMonth}</Typography>
                </Box>
                <Box className="data-grid-box-row">
                  <InputLabel sx={{ color: 'rgba(235, 77, 77, 0.6)' }}>30 Day Notice:</InputLabel>
                  <Typography>{dayNotice}</Typography>
                </Box>
                <Box className="data-grid-box-row">
                  <InputLabel sx={{ color: 'rgba(187, 124, 239, 0.6)' }}>Pending:</InputLabel>
                  <Typography>{pending}</Typography>
                </Box>
              </>
            )}
          </Stack>
        }
      >
        <div>
          <MiniPieChart
            rowId={params?.row?.id}
            data={chartData}
            size={densityStyles?.svgSize}
            strokeWidth={4}
            context={'mtb'}
          />
        </div>
      </Tooltip>
      {/* ) : (
          <Typography>–</Typography>
        )} */}
    </Box>
  )
}
export default ActiveCountCell
